import { Box, Text } from '@chakra-ui/react';
import { NewsletterSignup } from 'components/common/NewsletterSignup';

export const BlogNewsletterSignup = () => (
  <Box borderRadius="base" bg="gray.100" p="m">
    <Text size="title2">Knowledge is power</Text>
    <Text size="title2" color="blackAlpha.700" mb="sm">
      Sign up to our newsletter
    </Text>
    <NewsletterSignup source="blog" />
  </Box>
);
